package fr.frux.core.common.platform

actual val platformId: String = "WEB"
